'use client';
import { NewGeneralDialog } from '@/components/NewGeneralDialog';
import { StepperStep } from '@/components/NewGeneralDialog/DialogStepper';
import { ROUTES } from '@/constants/routes';
import { useForgotPassword } from '@/hooks/useForgotPassword';
import { useGeneralDialogStepper } from '@/hooks/useGeneralDialogStepper';
import { Stack } from '@mui/material';
import { toLower, toString } from 'lodash';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EmailSent } from './EmailSent';
import { ForgotPassword } from './ForgotPassword';

enum ForgotPasswordSteps {
  EMAIL = 0,
  EMAIL_SENT = 1,
}

export default function ForgotPasswordPage() {
  const { t } = useTranslation();
  const STEPS: StepperStep[] = [
    {
      label: t('reset_password'),
      status: 'not_completed',
    },
    {
      label: t('reset_link_sent'),
      status: 'not_completed',
    },
  ];
  return (
    <NewGeneralDialog
      isOpen={true}
      steps={STEPS}
      initialActiveStepIndex={ForgotPasswordSteps.EMAIL}
      slotsProps={{
        topBar: {
          children: <></>,
        },
      }}>
      <DialogBody />
    </NewGeneralDialog>
  );
}

const DialogBody = () => {
  const { replace } = useRouter();
  const { data, mutate: forgotPassword } = useForgotPassword();
  const [onNext, setOnNext] = useState(true);
  const { moveBackward, moveForward, activeStepIndex } =
    useGeneralDialogStepper();

  const handleNextStep = () => {
    setOnNext(true);
    setTimeout(() => {
      moveForward();
    }, 100);
  };

  const handlePreviousStep = () => {
    setOnNext(false);
    setTimeout(() => {
      moveBackward();
    }, 100);
  };

  const handleEmailSubmit = (values: { email: string }) => {
    forgotPassword(toLower(values.email), {
      onSuccess: () => {
        handleNextStep();
      },
    });
  };
  return (
    <Stack
      height="100%"
      width="100%"
      alignItems="center"
      justifyContent="center">
      {activeStepIndex === ForgotPasswordSteps.EMAIL && (
        <ForgotPassword
          onMovingBackward={() => replace(ROUTES.login)}
          onMovingForward={handleEmailSubmit}
          onNext={onNext}
        />
      )}

      {activeStepIndex === ForgotPasswordSteps.EMAIL_SENT && (
        <EmailSent
          email={toString(data?.data.email)}
          onResendClick={handlePreviousStep}
          onNext={onNext}
        />
      )}
    </Stack>
  );
};
